import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TOKEN } from '../utils/constant';

export const authGuard: CanActivateFn = () => {
  // const token = localStorage.getItem(TOKEN) ?? '';
  // if (token == '') {
  //   window.location.href = environment.LoginSSOROP;
  // }
  // return true;

  const router = inject(Router);
  const token = localStorage.getItem(TOKEN);

  if (token) {
    return true;
  } else {
    router.navigate(['/']);
    return false;
  }
};
